import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import { awsAmplifyConfig, awsDevelopmentAmplifyConfig } from './config/AmplifyConfig'

// FIRST: Capture OAuth errors before Amplify processes them
console.log('🔍 [index.tsx] Checking for OAuth errors before Amplify configuration...');
console.log('🔍 [index.tsx] Current URL:', window.location.href);
console.log('🔍 [index.tsx] Search params:', window.location.search);

const urlParams = new URLSearchParams(window.location.search);
const error = urlParams.get('error');
const errorDescription = urlParams.get('error_description');

console.log('🔍 [index.tsx] Error param:', error);
console.log('🔍 [index.tsx] Error description:', errorDescription);

if (error === 'invalid_request' && errorDescription?.includes('EXISTING_ACCOUNT_REQUIRES_LINKING')) {
  console.log('🔗 [index.tsx] OAuth account linking error detected, storing in sessionStorage');
  
  // Extract both email and username from the error description using regex
  let extractedEmail = 'user@example.com'; // fallback
  let extractedUsername = 'user@example.com'; // fallback
  
  // Parse email and username from error description: "EXISTING_ACCOUNT_REQUIRES_LINKING. Email: user@example.com. Username: actual_username"
  const emailMatch = errorDescription.match(/Email:\s*([^\s]+)/);
  const usernameMatch = errorDescription.match(/Username:\s*([^\s.]+)/);
  
  if (emailMatch && emailMatch[1]) {
    extractedEmail = emailMatch[1];
    console.log('✅ [index.tsx] Successfully extracted email from error description:', extractedEmail);
  } else {
    console.warn('⚠️ [index.tsx] Could not extract email from error description:', errorDescription);
  }
  
  if (usernameMatch && usernameMatch[1]) {
    extractedUsername = usernameMatch[1];
    console.log('✅ [index.tsx] Successfully extracted username from error description:', extractedUsername);
  } else {
    console.warn('⚠️ [index.tsx] Could not extract username from error description, using email as fallback:', errorDescription);
    extractedUsername = extractedEmail; // Use email as fallback
  }
  
  const state = urlParams.get('state');
  
  // Store the error state in sessionStorage so it survives Amplify's URL clearing
  sessionStorage.setItem('oauthAccountLinkingError', JSON.stringify({
    error: error,
    errorDescription: errorDescription,
    state: state,
    extractedEmail: extractedEmail,
    extractedUsername: extractedUsername,
    timestamp: Date.now()
  }));
  
  console.log('🔗 [index.tsx] OAuth error stored successfully with email and username:', { email: extractedEmail, username: extractedUsername });
} else {
  console.log('🔍 [index.tsx] No OAuth account linking error detected');
}

console.log("Clinton test, configuring amplify 3");

if (process.env.NODE_ENV === "development") {
  console.log("Clinton test, configuring amplify 1");
  Amplify.configure(awsDevelopmentAmplifyConfig);
} else {
  console.log("Clinton test, configuring amplify 2  process.env.REACT_APP_USER_POOL_I = " + process.env.REACT_APP_USER_POOL_ID);
  Amplify.configure(awsAmplifyConfig);
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
